import { ESPConnection } from "../espConnection";
var DFUService = /** @class */ (function () {
    function DFUService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "WsDFU", "1.35");
    }
    DFUService.prototype.DFUQuery = function (request) {
        return this._connection.send("DFUQuery", request);
    };
    return DFUService;
}());
export { DFUService };
//# sourceMappingURL=wsDFU.js.map